import { render, staticRenderFns } from "./PortraitPhoto.vue?vue&type=template&id=7bd8693a&scoped=true"
import script from "./PortraitPhoto.vue?vue&type=script&lang=js"
export * from "./PortraitPhoto.vue?vue&type=script&lang=js"
import style0 from "./PortraitPhoto.vue?vue&type=style&index=0&id=7bd8693a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8693a",
  null
  
)

export default component.exports